import React from 'react'
import { Button, SimpleModal, ModalTitle, ModalContent, ModalFooter } from '@deal/components'
import styles from './styles.css'

interface ShareModalProps {
  isOpen: boolean
  onCloseModal: () => void
  onSend: () => void
  content: string
  input: React.ReactNode
  buttonText?: string
}

const ShareTextModal: React.SFC<ShareModalProps> = ({
  isOpen,
  buttonText,
  onCloseModal,
  content,
  input,
  onSend
}) => (
  <SimpleModal isOpen={isOpen} onRequestClose={onCloseModal} overlayClassName={styles.modalOverlay}>
    <ModalTitle className={styles.title}>Send to a friend</ModalTitle>
    <ModalContent className={styles.modalContent}>
      <p className={styles.modalText}>{content}</p>
      {input}
    </ModalContent>
    <ModalFooter className={styles.modalFooter}>
      <Button onClick={onSend} variant="black">
        {buttonText ? buttonText : 'Send'}
      </Button>
    </ModalFooter>
  </SimpleModal>
)

export default ShareTextModal
